// src/components/AccountChecker/HowItWorks.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const HowItWorks = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <section className="how-it-works-section">
      <div className="section-head-line">
        <span className="section-mono-title">
          {isEn ? 'Verification Algorithm' : 'Алгоритм проверки'}
        </span>
      </div>

      <div className="how-grid">
        {/* Шаг 1 */}
        <div className="how-step-card">
          <svg className="how-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="8" r="5" />
            <path d="M20 21a8 8 0 1 0-16 0" />
          </svg>
          <div className="how-card-inner">
            <div className="step-badge-top">
              <span className="step-number-tag">{isEn ? 'Step 01' : 'Шаг 01'}</span>
              <div className="step-icon-wrap">
                <svg viewBox="0 0 24 24">
                  <circle cx="12" cy="8" r="5" />
                  <path d="M20 21a8 8 0 1 0-16 0" />
                </svg>
              </div>
            </div>
            <h3 className="step-card-title">
              {isEn ? 'Enter Username' : 'Введите Имя Пользователя'}
            </h3>
            <p className="step-card-desc">
              {isEn
                ? 'Enter the Minecraft username you wish to verify.'
                : 'Введите имя пользователя Minecraft, которое вы хотите проверить.'}
            </p>
          </div>
        </div>

        {/* Шаг 2 */}
        <div className="how-step-card">
          <svg className="how-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <ellipse cx="12" cy="5" rx="9" ry="3" />
            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
            <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
          </svg>
          <div className="how-card-inner">
            <div className="step-badge-top">
              <span className="step-number-tag">{isEn ? 'Step 02' : 'Шаг 02'}</span>
              <div className="step-icon-wrap">
                <svg viewBox="0 0 24 24">
                  <ellipse cx="12" cy="5" rx="9" ry="3" />
                  <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
                  <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
                </svg>
              </div>
            </div>
            <h3 className="step-card-title">
              {isEn ? 'Search In Database' : 'Поиск в Базе Данных'}
            </h3>
            <p className="step-card-desc">
              {isEn
                ? 'We query credentials across our comprehensive breach database.'
                : 'Мы ищем учетные данные в нашей обширной базе данных утечек.'}
            </p>
          </div>
        </div>

        {/* Шаг 3 */}
        <div className="how-step-card">
          <svg className="how-backdrop-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <polyline points="9 12 11 14 15 10" />
          </svg>
          <div className="how-card-inner">
            <div className="step-badge-top">
              <span className="step-number-tag">{isEn ? 'Step 03' : 'Шаг 03'}</span>
              <div className="step-icon-wrap">
                <svg viewBox="0 0 24 24">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <polyline points="9 12 11 14 15 10" />
                </svg>
              </div>
            </div>
            <h3 className="step-card-title">
              {isEn ? 'Get Results' : 'Получите Результаты'}
            </h3>
            <p className="step-card-desc">
              {isEn
                ? 'Review detected credentials and relevant security intelligence.'
                : 'Получите найденные учетные данные и информацию о безопасности.'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;